import React from 'react';
import { SvgIcon, Row, Col, ContentBlock, CourseImage } from 'seduo-ui';
import ReactRating from 'react-rating';
const HorizontalCardFinishedWithRating = () => (<ContentBlock className="my-courses">
        <Row className="course-row">
            <Col sm={4} lg={2} className="pr-sm-0">
                <a href={'#'}>
                    <CourseImage src={'https://dummyimage.com/222x150/9fa4a8/fff.png'} alt={'Default course image'} isFinished/>
                </a>
            </Col>
            <Col sm={7} className="align-self-stretch">
                <Row className="course-row__main">
                    <Col lg={7} className="course-row__info">
                        <a href={'#'} className="course-row__info-title font-weight-medium" title="Course Title">
                            <div className="text-truncate-multiline text-truncate-multiline-2">Course Title</div>
                        </a>
                        <div className="course-row__info-subtitle">
                            <div className="mb-5">
                                <a href={'#'} className="course-row__info-link">
                                    John Lector
                                </a>
                                ,{' '}
                                <a href={'#'} className="course-row__info-link">
                                    Francis Teacher
                                </a>
                            </div>
                            <div className="course-row__info-text">
                                <span className="mr-6">123h 45m</span>
                                <span>666 lekcí</span>
                            </div>
                        </div>
                    </Col>
                    <Col lg={5} className="course-row__activity">
                        <div className="course-row__activity-course-rating mt-5 mt-lg-0">
                            <div className="rating">
                                <ReactRating className="rating__stars" initialRating={5} emptySymbol={<SvgIcon size={15} kind="StarOutline" className="rating__star"/>} fullSymbol={<SvgIcon size={15} kind="Star" className="rating__star"/>} readonly/>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col>
            <Col lg={3} className="d-lg-flex">
                <div className="course-row__actions">
                    <a className="btn btn-secondary btn-sm course-row__actions-button" href={'#'} role="button">
                        <SvgIcon kind="Download" height="13" width="15" className="course-row__actions-icon course-row__actions-icon--primary align-middle"/>
                        Certifikát
                    </a>
                    <a className="btn btn-link btn-sm text-muted course-row__actions-button" href="#" role="button">
                        <SvgIcon kind="Reload" size={15} className="course-row__actions-icon course-row__actions-icon--link align-middle"/>
                        Spustit znovu
                    </a>
                </div>
            </Col>
        </Row>
    </ContentBlock>);
const Example = () => <HorizontalCardFinishedWithRating />;
export default Example;
